(function () {
  const MAX_WAIT_MS = 10000;
  const POLL_MS = 100;

  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  async function waitFor(conditionFn, { timeoutMs = MAX_WAIT_MS, pollMs = POLL_MS } = {}) {
    const start = Date.now();
    while (Date.now() - start < timeoutMs) {
      try {
        if (conditionFn()) return true;
      } catch (_) {}
      await sleep(pollMs);
    }
    return false;
  }

  function qsa(root, sel) {
    return Array.from(root.querySelectorAll(sel));
  }

  function initSwipers() {
    document.querySelectorAll(".swiperv4").forEach((el) => {
      // Avoid double-init
      if (el.swiper || el.swiperInst) return;

      const inst = new Swiper(el, {
        slidesPerView: 2.2,
        spaceBetween: 15,
        loop: false,
        shortSwipes: true,
        a11y: false,
        freeMode: { enabled: true, sticky: false, momentumBounce: false },
        mousewheel: { forceToAxis: true, sensitivity: 1, releaseOnEdges: true },
        navigation: {
          nextEl: el.parentElement?.querySelector(".swiper-button-next22"),
          prevEl: el.parentElement?.querySelector(".swiper-button-prev22"),
        },
        breakpoints: {
          640: { slidesPerView: 2.2 },
          768: { slidesPerView: 2.2 },
          1024: { slidesPerView: 4 },
        },
      });

      // Keep your custom reference (optional)
      el.swiperInst = inst;
    });
  }

  function applyFilter(btn) {
    const tabsFilter = btn.closest(".tabs_filter");
    if (tabsFilter) {
      qsa(tabsFilter, ".tab_filter").forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");
    }

    const filter = btn.getAttribute("data-tab");

    // Case 1: swiper tabs filter
    const swiperTabs = btn.closest(".swiper_tabs_filter");
    if (swiperTabs) {
      const swiperEl = swiperTabs.querySelector(".swiperv4");
      const swiper = swiperEl?.swiper || swiperEl?.swiperInst;

      const slides = qsa(swiperTabs, ".swiper-slide");
      slides.forEach((slide) => {
        slide.classList.toggle("slide-none", slide.dataset.filter !== filter);
      });

      if (swiper) {
        swiper.update();
        swiper.slideTo(0, 0);
      }

      // Slick still requires jQuery if you keep slick on the page
      slides
        .filter((s) => !s.classList.contains("slide-none"))
        .forEach((slide) => {
          qsa(slide, ".media_slider").forEach((ms) => {
            if (window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) {
              const $ms = window.jQuery(ms);
              if ($ms.hasClass("slick-initialized")) {
                $ms.slick("setPosition");
              } else {
                $ms.slick({
                  dots: true,
                  infinite: true,
                  speed: 300,
                  arrows: false,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  lazyLoad: "ondemand",
                });
              }
            }
          });
        });

      return;
    }

    // Case 2: shop category tab
    const shopTab = btn.closest(".shop_category_tab");
    if (shopTab) {
      const items = qsa(shopTab, "[data-filter]");
      items.forEach((item) => {
        item.classList.toggle("slide-none", item.dataset.filter !== filter);
      });
    }
  }

  function bindHandlersOnce() {
    if (window.__tabsFilterBound) return;
    window.__tabsFilterBound = true;

    document.addEventListener("click", (e) => {
      const btn = e.target.closest(".tab_filter");
      if (!btn) return;
      applyFilter(btn);
    });
  }

  function triggerInitialActive() {
    document.querySelectorAll(".tab_filter.active").forEach((btn) => applyFilter(btn));
  }

  async function bootstrap() {
    // Wait until Swiper is available AND the target elements exist (or timeout after 10s)
    const ready = await waitFor(
      () => typeof window.Swiper === "function" && document.querySelector(".swiperv4, .tab_filter"),
      { timeoutMs: MAX_WAIT_MS, pollMs: POLL_MS }
    );

    if (!ready) return; // stop waiting after 10s

    bindHandlersOnce();
    initSwipers();
    triggerInitialActive();

    // Optional: keep watching briefly for late-injected swipers within the same 10s window
    // (won't run longer than remaining time)
    const start = Date.now();
    while (Date.now() - start < MAX_WAIT_MS) {
      initSwipers();
      await sleep(300);
    }
  }

  bootstrap();
})();